import { buildLegend } from "@features/sales-v3/utils/tooltip";

export const ACTUAL_ID = "Actual";
export const ACTUAL_COLOR = "#C825A8";
export const ACTUAL_LEGEND = buildLegend(
  {
    borderColor: ACTUAL_COLOR,
    backgroundColor: ACTUAL_COLOR,
    borderDash: [],
  },
  false,
);

export const BUDGETED_ID = "Budgeted";
export const BUDGETED_COLOR = "#7081FF";
export const BUDGETED_LEGEND = buildLegend(
  {
    borderColor: BUDGETED_COLOR,
    backgroundColor: BUDGETED_COLOR,
    borderDash: [],
  },
  false,
);

export const LIVE_FORECAST_ID = "Projected";
export const LIVE_FORECAST_COLOR = "#C825A8";
export const LIVE_FORECAST_BORDER_DASH = [6, 2];
export const LIVE_FORECAST_LEGEND = buildLegend(
  {
    borderColor: LIVE_FORECAST_COLOR,
    backgroundColor: LIVE_FORECAST_COLOR,
    borderDash: LIVE_FORECAST_BORDER_DASH,
  },
  false,
);
